import { Directive } from '@angular/core';

@Directive({
  selector: 'xpo-empty-state-icon',
})
export class XpoEmptyStateIcon {}
